(() => {
  const hover = event => {
    if (!matchMedia('(hover: hover) and (pointer: fine)').matches || navigator.connection?.saveData) return;
    const template = event.target.closest('.card-product')?.querySelector('[data-card-hover-template]');
    if (template) template.replaceWith(template.content.cloneNode(true));
  };
  document.addEventListener('pointerover', hover, { passive: true });
  document.addEventListener('focusin', hover);
  let aiPromise;
  const loadAI = () => {
    if (customElements.get('nova-ai-suite')) return Promise.resolve();
    if (aiPromise) return aiPromise;
    const template = document.querySelector('[data-nova-ai-script]');
    if (!template) return Promise.reject(new Error('AI module unavailable'));
    aiPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = template.dataset.src;
      script.async = true;
      script.onload = () => {
        if (customElements.get('nova-ai-suite')) resolve();
        else { script.remove(); aiPromise = null; reject(new Error('AI module did not initialize')); }
      };
      script.onerror = () => { script.remove(); aiPromise = null; reject(new Error('AI module could not load')); };
      document.head.append(script);
    });
    return aiPromise;
  };
  document.addEventListener('pointerover', event => {
    if (event.target.closest('[data-ai-open]')) loadAI().catch(() => {});
  }, { passive: true });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-ai-open]');
    if (!button || customElements.get('nova-ai-suite')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    try { await loadAI(); button.removeAttribute('aria-busy'); button.click(); }
    catch { button.removeAttribute('aria-busy'); button.setAttribute('aria-label', document.querySelector('[data-nova-ai-script]')?.dataset.error || button.getAttribute('aria-label') || ''); }
  }, true);
})();
